import React, { useContext, useState } from "react"
import { Tabs, Space, Card } from "antd"
import { useTranslation } from "react-i18next"
import {
  Sliders,
  DollarSign,
  Package,
  Layers,
  Database,
  Volume2,
  TrendingUp,
  Mail,
} from "react-feather"
import ProductUnits from "./ProductUnits"
import ProductCategories from "./ProductCategories"
import CurrencyRate from "./CurrencyRate"
import DatabaseBackup from "./DatabaseBackup"
import AudioChange from "./AudioChange"
import Modes from "./Modes"
import KpiSettings from "./KpiSettings"
import KpiProductRules from "./KpiProductRules"
import EmailSettingsSection from "./EmailSettingsSection"
import { AuthContext } from "../../../../contexts/auth/AuthContext"
import { ThemeContext } from "../../../../contexts/ThemeContex"

export default function SiteSettingsTab() {
  const { t } = useTranslation()
  const { authState } = useContext(AuthContext)
  const { themeState } = useContext(ThemeContext)
  const isDark = themeState.currentTheme === "dark"
  const [subTab, setSubTab] = useState<string>("main")

  const isCounterparty = authState.user?.userName === "Counterparty"

  const cardStyle: React.CSSProperties = {
    marginBottom: 16,
    borderRadius: 10,
    backgroundColor: isDark ? "#211B2B" : "#F8FAFC",
    borderColor: isDark ? "rgba(255, 255, 255, 0.08)" : "#E2E8F0",
  }

  const titleStyle: React.CSSProperties = {
    fontSize: 14,
    fontWeight: 600,
    color: isDark ? "#FFFFFF" : "#0F172A",
  }

  return (
    <div style={{ marginTop: 8 }}>
      <Tabs
        activeKey={subTab}
        onChange={setSubTab}
        type="card"
        className="settings-sub-tabs"
        tabBarStyle={{ marginBottom: 16 }}
      >
        {/* BO'LIM 1: Asosiy & Valyuta kursi */}
        <Tabs.TabPane
          key="main"
          tab={
            <Space size={6}>
              <Sliders size={14} />
              <span>Asosiy & Valyuta</span>
            </Space>
          }
        >
          <Card
            size="small"
            title={
              <Space>
                <Sliders size={15} color="#2563EB" />
                <span style={titleStyle}>Interfeys Rejimlari va Shrift</span>
              </Space>
            }
            style={cardStyle}
          >
            <Modes />
          </Card>

          {!isCounterparty && (
            <Card
              size="small"
              title={
                <Space>
                  <DollarSign size={15} color="#10B981" />
                  <span style={titleStyle}>Valyuta (Dollar) Kursi Boshqaruvi</span>
                </Space>
              }
              style={cardStyle}
            >
              <CurrencyRate />
            </Card>
          )}
        </Tabs.TabPane>

        {/* BO'LIM 2: Katalog & O'lchov birliklari */}
        {!isCounterparty && (
          <Tabs.TabPane
            key="catalog"
            tab={
              <Space size={6}>
                <Package size={14} />
                <span>Katalog & Birliklar</span>
              </Space>
            }
          >
            <Card
              size="small"
              title={
                <Space>
                  <Layers size={15} color="#6366F1" />
                  <span style={titleStyle}>O'lchov Birliklari</span>
                </Space>
              }
              style={cardStyle}
            >
              <ProductUnits />
            </Card>

            <Card
              size="small"
              title={
                <Space>
                  <Package size={15} color="#8B5CF6" />
                  <span style={titleStyle}>Mahsulot Toifalari (Kategoriya)</span>
                </Space>
              }
              style={cardStyle}
            >
              <ProductCategories />
            </Card>
          </Tabs.TabPane>
        )}

        {/* BO'LIM 3: Tizim & Moliya / KPI */}
        {!isCounterparty && (
          <Tabs.TabPane
            key="system"
            tab={
              <Space size={6}>
                <Database size={14} />
                <span>{t("settingsSystemTab")}</span>
              </Space>
            }
          >
            <Card
              size="small"
              title={
                <Space>
                  <Volume2 size={15} color="#EC4899" />
                  <span style={titleStyle}>{t("settingsAudioTitle")}</span>
                </Space>
              }
              style={cardStyle}
            >
              <AudioChange />
            </Card>

            <Card
              size="small"
              title={
                <Space>
                  <Database size={15} color="#0EA5E9" />
                  <span style={titleStyle}>{t("dbBackupTitle")}</span>
                </Space>
              }
              style={cardStyle}
            >
              <DatabaseBackup />
            </Card>

            <Card
              size="small"
              title={
                <Space>
                  <TrendingUp size={15} color="#F59E0B" />
                  <span style={titleStyle}>{t("settingsKpiTitle")}</span>
                </Space>
              }
              style={cardStyle}
            >
              <KpiSettings />
            </Card>

            {/* Tovar bo'yicha alohida KPI qoidalari — to'lov turi bo'yicha
                umumiy sozlamadan alohida ishlaydi */}
            <Card
              size="small"
              title={
                <Space>
                  <TrendingUp size={15} color="#10B981" />
                  <span style={titleStyle}>{t("kpiRulesTitle")}</span>
                </Space>
              }
              style={cardStyle}
            >
              <KpiProductRules />
            </Card>
          </Tabs.TabPane>
        )}

        {/* BO'LIM 4: Email & SMTP Sozlamalari */}
        {!isCounterparty && (
          <Tabs.TabPane
            key="email"
            tab={
              <Space size={6}>
                <Mail size={14} />
                <span>Email & SMTP</span>
              </Space>
            }
          >
            <Card
              size="small"
              title={
                <Space>
                  <Mail size={15} color="#2563EB" />
                  <span style={titleStyle}>Tizim Email (SMTP) Sozlamalari va Test</span>
                </Space>
              }
              style={cardStyle}
            >
              <EmailSettingsSection />
            </Card>
          </Tabs.TabPane>
        )}
      </Tabs>
    </div>
  )
}
